import * as React from "react";
import { Stack, useFocusEffect, useNavigation } from "expo-router";
import { Controller } from "react-hook-form";

import { ModalHeaderTitle } from "~/components/HeaderElements";
import SaveFormForm from "~/components/SaveForm/SaveForm.form";
import { useSaveFormContext } from "~/components/SaveForm/shared";

export default function LinkForm() {
  const { control, setValue, getValues } = useSaveFormContext();
  const isUpdating = getValues("intent") === "update";

  useFocusEffect(() => {
    setValue("step", "form");
  });

  const accountLayout = useNavigation("/(app)/(authenticated)/[account]");
  useFocusEffect(() => {
    accountLayout.setOptions({
      sheetAllowedDetents: "fitToContents",
    });
  });

  const saveType = getValues("type");

  return (
    <>
      <Controller
        control={control}
        name="url"
        render={({ field }) => (
          <Stack.Screen
            options={{
              headerTitle() {
                const title = (() => {
                  switch (saveType) {
                    case "URL": {
                      let hostname = "";
                      try {
                        hostname = new URL(field.value ?? "").hostname.replace(
                          "www.",
                          "",
                        );
                      } catch {}
                      if (!hostname) return "Save link";
                      if (isUpdating) return `Update ${hostname} link`;
                      return `Save ${hostname} link`;
                    }
                    case "MEDIA": {
                      return "Add media";
                    }
                    default: {
                      return "";
                    }
                  }
                })();

                return <ModalHeaderTitle>{title}</ModalHeaderTitle>;
              },
            }}
          />
        )}
      />

      <SaveFormForm />
    </>
  );
}
